// components
import { ReactComponent as ReactLogo } from "assets/icons/logo.svg";

const PoliformLogo = () => {
  return <ReactLogo style={{ width: "105px" }} />;
};
export { PoliformLogo };
